import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'

const styles = theme => ({})
export default withStyles(styles)(
  class CategorySelectionComponent extends Component {
    static propTypes = {
      className: PropTypes.string,
      selectedCategory: PropTypes.object.isRequired,
      categories: PropTypes.array.isRequired,
      onChange: PropTypes.func.isRequired
    }
    static defaultProps = {
      categories: []
    }
    handleChange = name => e => {
      const { categories } = this.props
      const key = e.target.value
      const category = categories.find(c => c.key === key)
      this.props.onChange(category)
    }

    render() {
      const { className, categories, selectedCategory } = this.props
      return (
        <FormControl fullWidth={!!className} className={className}>
          <InputLabel htmlFor="category-select">Catégorie</InputLabel>
          <Select
            value={selectedCategory.key}
            onChange={this.handleChange('category')}
            inputProps={{
              name: 'category',
              id: 'category-select'
            }}>
            {categories.map(c => (
              <MenuItem key={c.key} value={c.key}>
                {`${c.name}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/category/CategorySelectionComponent.js